import { css, styled } from 'canoe';
import { compose, connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';

import { Snapshot } from '@candu-ai/snapshots/types';

import { NoSnapshotThumbnail } from './NoSnapshotThumbnail';

export const SnapshotThumbnailWrapper = styled.div<{ src?: string }>`
  ${({ theme, src = '' }) => css`
    width: 100%;
    height: 155px;
    background-image: url(${src});
    background-color: ${theme.colors.OnyxGrayL20};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    border: 1px solid ${theme.colors.OnyxGrayL20};
    border-radius: ${theme.borderRadius.small};
  `}
`;

interface SnapshotThumbnailProps {
  snapshotId?: string;
  contentId: string;
  snapshots: Snapshot[];
}

const SnapshotThumbnailImpl = ({ snapshotId, snapshots }: SnapshotThumbnailProps) => {
  const snapshot = snapshots.find((s) => s.id === snapshotId);
  return snapshot ? (
    <SnapshotThumbnailWrapper src={snapshot.thumbnailLgS3Url} />
  ) : (
    <NoSnapshotThumbnail />
  );
};

const withSnapshots = connectWithHammock(({ contentId }) => ({
  resourceName: 'snapshots',
  endpoint: ENDPOINTS.snapshots,
  query: { finder: 'byContentId', id: contentId },
}));

export const SnapshotThumbnail = compose(withSnapshots)(SnapshotThumbnailImpl);
